import { bufferTime, filter, map } from 'rxjs/operators';
import { ILogAdapterService, LOG_ADAPTER_SERVICE } from '../message-adapters/log-adapter';
import { IMonitoringBody, IMonitoringStream } from '../../interfaces';
import { IMonitoringWithBufferService } from './monitoring-with-buffer.interface';
import { inject, injectable } from 'inversify';
import { Subject } from 'rxjs';

const BUFFER_TIME_SPAN = 5_000;

@injectable()
export class MonitoringWithBufferService implements IMonitoringWithBufferService {

    @inject(LOG_ADAPTER_SERVICE) private readonly logAdapterSrv: ILogAdapterService;

    private buffer: Subject<IMonitoringStream>;

    send(data: IMonitoringStream): void {
        if (!Boolean(this.buffer)) {
            this.init();
        }

        this.buffer.next(data);
    }

    private init() {
        this.buffer = new Subject();

        this.buffer
            .pipe(
                bufferTime(BUFFER_TIME_SPAN),
                filter(array => Boolean(array.length)),
                map((streams: Array<IMonitoringStream>): IMonitoringBody => {
                    return {
                        streams,
                    };
                }),
            )
            .subscribe((body: IMonitoringBody) => {
                this.logAdapterSrv.send(body);
            });
    }
}
